<nav id="mainNav"
     class="navbar navbar-expand-lg navbar-light animated">
    <div class="container">
        <a class="navbar-brand"
           routerLink="/home"
           routerLinkActive="active"
           (click)="scrollToTop()">
            <img src="./assets/logo-octoplus-color.svg"
                 alt="Logo octoplus"
                 i18n-alt>
        </a>
        <button class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
                i18n-aria-label>
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse"
             id="navbarSupportedContent">
            <ul class="navbar-nav nav-central mx-auto mb-2 mb-lg-0">
                <li class="nav-item">
                    <a class="nav-link"
                       routerLink="/home"
                       routerLinkActive="active"
                       (click)="scrollToTop()"
                    >
                        <span i18n>Home</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link"
                       routerLink="/training"
                       routerLinkActive="active"
                       (click)="scrollToTop()"
                    >
                        <span i18n>Training</span>
                    </a>
                </li>
                <!-- dropdown on click disabled on purpose, to be replaced by an hover dropdown -->
                <li class="nav-item">
                    <a class="nav-link"
                       role="button"
                       aria-expanded="false"
                       routerLink="/solutions"
                       (click)="scrollToTop()">
                        <span i18n>Solutions</span>
                    </a>
                    <div class="dropdown-menu"
                         aria-labelledby="navbarDropdown">
                        <div class="dropdown-menu-o">

                            <div class="left cursor-pointer" routerLink="/solutions">
                                <img src="./assets/logo-color.svg"
                                     alt="Logo octoplus"
                                     i18n-alt>
                                <div class="d-flex flex-column justify-content-between h-100">
                                    <div>
                                        <p class="text-xl-semibold" i18n>Overview of our digital solutions</p>
                                        <p class="text-sm-regular" i18n>Explore the future of business efficiency
                                            with
                                            Octoplus's advanced
                                            digital
                                            solutions. Tailored for dynamic cost management and carbon footprint
                                            monitoring,
                                            our tools empower smarter and sustainable decision-making.</p>
                                    </div>
                                    <a routerLink="/solutions"
                                       class="link link-primary link-arrow-left" i18n>Learn more
                                    </a>
                                </div>
                            </div>

                            <div class="right">
                                <ul>
                                    <li>
                                        <a class="item"
                                           routerLink="/cost-viewer"
                                           routerLinkActive="active"
                                           (click)="scrollToTop()"
                                        >
                                            <i>
                                                <fa-icon [icon]="['fas', 'coins']"></fa-icon>
                                            </i>
                                            <div>
                                                <p class="text-lg-semibold" i18n>Cost Viewer</p>
                                                <p class="text-xs-regular" i18n>An advanced software that leverages
                                                    over two
                                                    decades of industry
                                                    expertise to empower your business with precise cost management and
                                                    competitive pricing strategies.
                                                </p>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="item"
                                           routerLink="/dashboard-serie"
                                           routerLinkActive="active"
                                           (click)="scrollToTop()"
                                        >
                                            <i>
                                                <fa-icon [icon]="['fas', 'coins']"></fa-icon>
                                            </i>
                                            <div>
                                                <p class="text-lg-semibold" i18n>Dashboard serie</p>
                                                <p class="text-xs-regular" i18n>Designed to seamlessly connect with your ERP
                                                    and collect the analyses of all references purchased or sold by your
                                                    organization.
                                                </p>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="item"
                                           routerLink="/dashboard-program"
                                           routerLinkActive="active"
                                           (click)="scrollToTop()">
                                            <i>
                                                <fa-icon [icon]="['fas', 'chart-network']"></fa-icon>
                                            </i>
                                            <div>
                                                <p class="text-lg-semibold" i18n>Dashboard program</p>
                                                <p class="text-xs-regular" i18n>Web application designed to help you
                                                    precisely price references during the program phase.
                                                </p>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="item"
                                           routerLink="/ebom-manager"
                                           routerLinkActive="active"
                                           (click)="scrollToTop()">
                                            <i>
                                                <fa-icon [icon]="['fas', 'folder-tree']"></fa-icon>
                                            </i>
                                            <div>
                                                <p class="text-lg-semibold" i18n>Ebom manager</p>
                                                <p class="text-xs-regular" i18n>An online Bill of Materials (BOM) software
                                                    for managing the various components and assemblies involved in
                                                    product development and manufacturing.
                                                </p>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="item"
                                           routerLink="/octoplus-impulse"
                                           routerLinkActive="active"
                                           (click)="scrollToTop()">
                                            <i>
                                                <fa-icon [icon]="['fas', 'earth-europe']"></fa-icon>
                                            </i>
                                            <div>
                                                <p class="text-lg-semibold" i18n>Octoplus Impulse</p>
                                                <p class="text-xs-regular" i18n>A next-generation web portal designed to
                                                    bring unparalleled transparency and efficiency to managing the
                                                    ecological footprint across the supply chain.
                                                </p>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="nav-item">
                    <a class="nav-link"
                       href="/about-us" i18n>About us
                    </a>
                </li>
            </ul>
            <div class="d-flex align-items-center gap-24">
                <div class="language-selector">
                    <button class="language-toggle"
                            type="button"
                            (click)="toggleLanguageDropdown()"
                            [attr.aria-expanded]="isLanguageDropdownOpen">
                        {{currentLanguage.prefix.toUpperCase()}}
                    </button>
                    <ul class="language-dropdown" [class.show]="isLanguageDropdownOpen">
                        @for (lang of languages; track lang.code) {
                            <li>
                                <a class="language-item"
                                   [class.active]="lang.code === currentLanguage.code"
                                   (click)="switchLanguage(lang)">
                                    {{lang.label}}
                                </a>
                            </li>
                        }
                    </ul>
                </div>
                <a href="./contact-us"
                   class="btn btn-primary" i18n>Contact
                </a>
            </div>
        </div>
    </div>
</nav>
